<cna-loading-content [loading]="loading$ | async">
    <div *ngIf="mustUpdate$ | async as mustUpdate; else noUpdate">
        <cna-page-heading
            pageHeadingTitle="Hinweis zu Ihrem Lehrgang"
        ></cna-page-heading>
        <p class="adelle-sans-17 font-weight-300 dark-gray mt-4">
            Die Lehrinhalte wurden überarbeitet. Um mit dem Lehrgang in der
            aktualisierten Version fortzufahren, ist eine Migration
            erforderlich.
        </p>
        <p class="adelle-sans-17 font-weight-300 dark-gray">
            Bitte beachten Sie:
        </p>
        <ul class="adelle-sans-17 font-weight-300 dark-gray">
            <li>
                Sowohl Ihr bisheriger <strong>Lernfortschritt</strong> als auch
                die erfassten <strong>Lernzeiten</strong> werden
                <strong>vollständig übernommen</strong>.
            </li>
            <li>
                Ihre persönlichen <strong>Notizen</strong> werden
                <strong>nicht übernommen</strong>.
            </li>
        </ul>
        <p class="adelle-sans-17 font-weight-300 dark-gray">
            Wir empfehlen daher, Ihre Notizen vor der Migration
            <a [routerLink]="'../../../notes'" class="blue-color underlined"
                >herunterzuladen</a
            >, sofern Sie diese weiterhin benötigen.
        </p>
        <p class="adelle-sans-17 font-weight-300 dark-gray">
            Nach Abschluss der Migration steht Ihnen Ihr Lehrgang mit den
            aktualisierten Lehrinhalten zur Verfügung.
        </p>
        <cna-gradient-button
            buttonTitle="Jetzt migrieren"
            (click)="migrate()"
            class="mt-2"
        ></cna-gradient-button>
    </div>
    <ng-template #noUpdate>
        <div
            *ngIf="module$ | async as module"
            class="module-overview-container"
        >
            <div style="display: flex; justify-content: center">
                <div class="sizeTable" style="width: 1163px">
                    <div>
                        <cna-page-heading
                            *ngIf="
                                (courseType$ | async) ===
                                CourseType.EducationCourse
                            "
                            pageHeadingTitle="{{
                                moduleName$ | async
                            }} – Übersicht"
                        ></cna-page-heading>
                        <cna-page-heading
                            *ngIf="
                                (courseType$ | async) ===
                                CourseType.TrainingCourse
                            "
                            pageHeadingTitle="{{
                                (courseParticipation$ | async)?.bookedCourse
                                    ?.targetReadingTime
                            }}-stündige Fortbildung im Selbststudium"
                        ></cna-page-heading>
                    </div>
                    <div *ngIf="courseName$ | async" style="margin-top: 12px">
                        <p class="adelle-sans-17 font-weight-300 dark-gray">
                            {{ courseName$ | async }}
                        </p>
                    </div>
                </div>
            </div>

            <div
                class="d-flex justify-content-center mt-4"
                *ngIf="module.moduleType === LearnModuleType.Repetitorium"
            >
                <div class="sizeTable">
                    <ngb-accordion #acc="ngbAccordion" class="description">
                        <ngb-panel cardClass="accordion-title">
                            <ng-template ngbPanelTitle>
                                <img
                                    src="assets/Pfeil_Accordion-unten.svg"
                                    alt="acc-arrow"
                                    class="acc-arrow"
                                />
                                <span
                                    class="learntime-accordion-ebene1-t1-text adelle-sans-17 dark-gray font-weight-600"
                                    >Einführung</span
                                >
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <p
                                    class="adelle-sans-17 font-weight-300 dark-gray"
                                >
                                    Das AK JURA Modul »Repetitorium« dient der
                                    Vorbereitung auf Ihre Abschlussprüfung. Hier
                                    sind alle prüfungsrelevanten Themen Ihres
                                    Fachgebiets so komprimiert und
                                    zusammengefasst, dass Ihr Prüfungserfolg
                                    gewährleistet ist. <br /><br />
                                    Die für die Prüfung benötigten (und
                                    zugelassenen) Gesetzesmaterialien
                                    entsprechen denen, die Sie für die
                                    Bearbeitung des nachfolgenden Repetitoriums
                                    benötigen.
                                </p>
                            </ng-template>
                        </ngb-panel>
                    </ngb-accordion>
                </div>
            </div>

            <div>
                <div
                    style="
                        display: flex;
                        justify-content: center;
                        margin-top: 24px;
                    "
                >
                    <div class="sizeTable">
                        <cna-learning-module-accordion
                            [moduleName]="moduleName$ | async"
                            [moduleDocumentInfo]="module"
                            [sidebar]="false"
                            [courseType]="
                                (courseParticipation$ | async)?.bookedCourse
                                    ?.type
                            "
                        ></cna-learning-module-accordion>
                    </div>
                </div>

                <div
                    class="d-flex justify-content-center mt-4 pb-2 gray-background"
                    *ngIf="module.moduleType !== LearnModuleType.Repetitorium"
                >
                    <div class="learncontrol mb-5 mt-5">
                        <p
                            class="adelle-pe-31 font-weight-400 dark-gray"
                            style="margin-bottom: 32px"
                        >
                            Lernkontrolle
                        </p>
                        <p
                            *ngIf="!(isModuleReadAndMarkedDone() | async)"
                            class="adelle-sans-17 font-weight-300 dark-gray"
                        >
                            Die Lernkontrolle steht Ihnen zur Verfügung, nachdem
                            Sie das Modul <br />
                            vollständig bearbeitet haben. Dazu müssen Ihr
                            Lernfortschritt 100 % und <br />
                            Ihre Lernzeit mindestens
                            {{ (module$ | async)?.targetReadingTime / 3600 }}
                            Stunden betragen.
                        </p>
                        <p
                            class="adelle-sans-17 font-weight-300 dark-gray"
                            *ngIf="
                                (isModuleReadAndMarkedDone() | async) &&
                                !(controlTestPassed$ | async)
                            "
                        >
                            Sie haben die Lernkontrolle für dieses Modul noch
                            nicht bestanden. <br />
                            Nicht bestandene Lernkontrollen können wiederholt
                            werden.
                        </p>
                        <p
                            class="adelle-sans-17 font-weight-300 dark-gray"
                            *ngIf="controlTestPassed$ | async"
                        >
                            Sie haben die Lernkontrolle bereits erfolgreich
                            bestanden.
                            <br />
                            Bestandene Lernkontrollen können nicht wiederholt
                            werden.

                            <span
                                *ngIf="
                                    courseParticipation$
                                        | async as courseParticipation
                                "
                                class="download-btn"
                            >
                                <button
                                    (click)="
                                        downloadLearnControlPdf(
                                            module,
                                            courseParticipation
                                        )
                                    "
                                    class="d-flex flex-row align-items-baseline"
                                >
                                    <img
                                        style="
                                            margin-left: 6px;
                                            width: 25px;
                                            transform: translateY(2px);
                                        "
                                        src="assets/mehr_grey_2.svg"
                                    />
                                    <div
                                        class="font-weight-600 adelle-sans-11 dark-gray letterSpacing-073"
                                        style="margin-left: 4px"
                                    >
                                        {{
                                            courseParticipation.bookedCourse
                                                .type ===
                                            CourseType.EducationCourse
                                                ? 'Ihr Nachweis'
                                                : 'Zertifikat herunterladen'
                                        }}
                                    </div>
                                </button>
                            </span>
                        </p>

                        <div style="margin-top: 53px">
                            <cna-gradient-button
                                (akClick)="startLearnControl()"
                                buttonTitle="Lernkontrolle starten"
                                [disabled]="
                                    !(isModuleReadAndMarkedDone() | async) ||
                                    (controlTestPassed$ | async)
                                "
                                notgradient="true"
                            ></cna-gradient-button>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div
                    class="d-flex justify-content-center pt-4"
                    style="margin-bottom: 32px"
                >
                    <div class="sizeTable">
                        <cna-page-heading
                            *ngIf="
                                (courseType$ | async) ===
                                CourseType.EducationCourse
                            "
                            pageHeadingTitle="Notizen – {{
                                moduleName$ | async
                            }}"
                        ></cna-page-heading>
                        <cna-page-heading
                            *ngIf="
                                (courseType$ | async) ===
                                CourseType.TrainingCourse
                            "
                            pageHeadingTitle="Notizen"
                        ></cna-page-heading>
                    </div>
                </div>

                <div class="d-flex justify-content-center pb-3">
                    <div class="notes-accordion">
                        <cna-notes-accordion
                            [notes]="notes$ | async"
                            [moduleName]="moduleName$ | async"
                            [moduleDocumentInfo]="module"
                        ></cna-notes-accordion>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</cna-loading-content>

<ng-template #learnTimeInfoModal let-modal>
    <div class="modal-header">
        <h5
            class="modal-title adelle-sans-17 letterSpacing-08 font-weight-600 dark-gray"
        >
            Wichtig!
        </h5>
    </div>
    <div class="modal-body adelle-sans-17 dark-gray">
        <p>
            Bitte absolvieren Sie die im Fernlehrgang vorgesehenen Lernzeiten
            ordnungsgemäß, persönlich und eigenständig.
        </p>
        <p>
            Die Lernzeiten werden systemseitig erfasst und protokolliert und als
            Bestandteil Ihres Zertifikats ausgewiesen.
        </p>
        <p>
            Das Zertifikat ist von Ihnen zusammen mit den Klausuren und der
            Fallliste Ihrer Rechtsanwaltskammer vorzulegen. Bei Auffälligkeiten
            ist eine Nachprüfung möglich.
        </p>
        <p>
            Automatisierte Abläufe, Manipulationsversuche oder Umgehungen der
            Zeiterfassung sind unzulässig und können zur Nichtanerkennung der
            Lernzeiten führen.
        </p>
    </div>
    <div class="modal-footer flex-column align-items-center">
        <div class="flex-column align-items-start">
            <cna-checkbox-input
                class=""
                label="Hinweis künftig nicht mehr anzeigen"
                [checked]="learnTimeInfoReadConsent"
                (changeEvent)="learnTimeInfoReadConsent = $event.checked"
            ></cna-checkbox-input>
            <cna-gradient-button
                buttonTitle="Ich habe den Hinweis gelesen und verstanden."
                (click)="acceptLearnTimeInfo(modal)"
                class="pb-2 align-self-center"
            ></cna-gradient-button>
        </div>
    </div>
</ng-template>
